export default {
  BUY: 'Mua',
  SELL: 'Bán',
  NEU: 'Trung Lập',
  HOLD: 'Giữ',
  NOCMT: 'Không Khuyến Nghị',

  stackBarChartTooltipBUY: 'Mua: %{percent}%',
  stackBarChartTooltipSELL: 'Bán: %{percent}%',
  stackBarChartTooltipNEU: 'Trung Lập: %{percent}%',
  stackBarChartTooltipHOLD: 'Giữ: %{percent}%',
  stackBarChartTooltipNOCMT: 'Không Khuyến Nghị: %{percent}%',
  targetPriceChange: '%{change}% Tỷ lệ Giảm',
  highest: 'Cao Nhất',
  average: 'Trung Bình',
  lowest: 'Thấp Nhất',

  targetPrice: 'Giá Mục Tiêu',
  actualPrice: 'Giá Thực Tế',
  numOfRating: 'SL khuyến nghị',

  consensusHistory: 'THỐNG KÊ GIÁ KHUYẾN NGHỊ',
  targetPriceTitle: 'GIÁ KHUYẾN NGHỊ',

  downside: '%{percent}% Giảm',
  upside: '%{percent}% Tăng',

  notice:
    '*Miễn trừ trách nhiệm: Nhà đầu tư cần lưu ý rằng dữ liệu được tính toán trong 3 tháng qua, kết quả dự phóng có thể không chính xác. Do vậy, dữ liệu này chỉ được sử dụng cho mục đích tham khảo. FiinGroup sẽ không chấp nhận và chịu trách nhiệm cho bất kỳ tổn thất nào của nhà đầu tư',
  recommendationTitle: 'KHUYẾN NGHỊ',

  lastestRecommendation: 'Khuyến Nghị Mới Nhất: ',

  price: 'Giá',

  recommendationHistoryTitle: 'Tỷ lệ Khuyến Nghị',

  sell: 'Bán',
  underweight: 'Tỷ trọng nhỏ',
  hold: 'Giữ',
  overweight: 'Tỷ trọng lớn',
  buy: 'Mua',
  noRecommendation: 'Khuyến Nghị',
  neutral: 'Trung Lập',
};
